// #238: auth (setup/login) page mount.
import { AuthPage } from '../auth.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(<AuthPage />);
